<template>
  <div class="coupon-list-s">
    <slot></slot>
    <div class="coupon-list-content">
      <div
        v-auth:click="{ method: clickCoupon, params: { coupon: item } }"
        v-for="(item, index) in couponList"
        :key="index"
        class="coupon-list__item"
      >
        <div class="item-content">
          <img :src="item.logo" alt class="logo" />
          <div class="title">
            <p>{{ item.title }}</p>
          </div>
          <div v-if="!item.is_client" class="get">免费领取</div>
          <div v-else class="get active">领取成功</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    couponList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    clickCoupon(item) {
      this.$emit('clickCoupon', item);
    },
  },
};
</script>

<style lang="scss" scoped>
//优惠券样式
$couponWidth: 300px;
$couponHeight: 166px;
$couponBg: #ffffff;
//优惠券名称宽度
$couponTitleWidth: 200px;
//领券状态部分样式
$getWidth: 175px;
$getheight: 40px;
$gotBg: linear-gradient(to right, #fffffd, #fff799);
//区块样式
$areaWidth: 710px;
$couponBg: url(~@this/assets/coupon1.png) center/contain no-repeat;

.coupon-list-s {
  position: relative;
  max-height: 340px;
  .coupon-list-content {
    width: 667px;
    margin: 0 auto;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
  }
  .coupon-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 50px 10px 40px;
    justify-content: space-around;
    &__item {
      font-size: 26px;
      margin-top: 20px;
      position: relative;
      .item-content {
        background: $couponBg;
        border-radius: 10px;
        width: $couponWidth;
        height: $couponHeight;
        z-index: 1;
        position: relative;
      }
      .logo {
        position: absolute;
        top: 20px;
        left: 20px;
        width: 72px;
        height: 72px;
        border-radius: 50%;
      }
      .title {
        position: absolute;
        top: 0;
        right: 10px;
        width: $couponTitleWidth;
        line-height: 34px;
        height: 34px * 3;
        display: flex;
        align-items: center;
        p {
          font-size: 22px;
          color: #1079f3;
        }
      }
      .get {
        color: #ff2f40;
        width: $getWidth;
        height: $getheight;
        line-height: $getheight;
        text-align: center;
        font-size: 24px;
        position: absolute;
        bottom: 10px;
        border-radius: $getheight/2;
        background: $gotBg;
        left: 50%;
        transform: translateX(-50%);
        &.active {
          color: #898989;
          background: linear-gradient(to left, #cbcbcb, #ffffff);
        }
      }
    }
  }
}
</style>
